import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "直播赛事", to: "/live" },
  { label: "赛程", to: "/schedule" },
  { label: "新闻", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
    setMobileSearchOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="hidden md:flex items-center gap-6 px-4 md:px-8 h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="flex w-9 h-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-basketball-fill text-xl" />
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            nba<span className="text-accent-500">直播</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3 w-full max-w-xs">
          <SearchBox />
        </div>
      </div>

      <div className="flex md:hidden items-center justify-between px-4 h-14">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex w-8 h-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-basketball-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            nba<span className="text-accent-500">直播</span>
          </span>
        </Link>
        <div className="flex items-center gap-1">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => {
              setMobileSearchOpen((v) => !v);
              setMobileOpen(false);
            }}
            className="flex w-10 h-10 items-center justify-center rounded-md text-foreground-700"
          >
            <i className="ri-search-line text-xl" />
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => {
              setMobileOpen((v) => !v);
              setMobileSearchOpen(false);
            }}
            className="flex w-10 h-10 items-center justify-center rounded-md text-foreground-700"
          >
            <i className={mobileOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {mobileSearchOpen && (
        <div className="md:hidden border-t border-background-200 px-4 py-3">
          <SearchBox onNavigate={() => setMobileSearchOpen(false)} />
        </div>
      )}

      {mobileOpen && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-2">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-md px-3 py-3 text-sm font-medium ${
                  isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700"
                }`
              }
            >
              <i className="ri-arrow-right-s-line text-lg" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}